const CP1252 = new Map([
  ['€', 0x80], ['‚', 0x82], ['ƒ', 0x83], ['„', 0x84], ['…', 0x85],
  ['†', 0x86], ['‡', 0x87], ['ˆ', 0x88], ['‰', 0x89], ['Š', 0x8a],
  ['‹', 0x8b], ['Œ', 0x8c], ['Ž', 0x8e], ['‘', 0x91], ['’', 0x92],
  ['“', 0x93], ['”', 0x94], ['•', 0x95], ['–', 0x96], ['—', 0x97],
  ['˜', 0x98], ['™', 0x99], ['š', 0x9a], ['›', 0x9b], ['œ', 0x9c],
  ['ž', 0x9e], ['Ÿ', 0x9f],
]);

function mojibakeScore(value) {
  return (String(value).match(/[ÂÃâðƒ�]/g) || []).length;
}

function encodeWindows1252(value) {
  const bytes = [];
  for (const character of String(value)) {
    const code = character.codePointAt(0);
    if (code <= 0xff) bytes.push(code);
    else if (CP1252.has(character)) bytes.push(CP1252.get(character));
    else return null;
  }
  return Uint8Array.from(bytes);
}

function decodeOnce(value) {
  const bytes = encodeWindows1252(value);
  if (!bytes) return value;
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes);
  } catch {
    return value;
  }
}

export function repairUtf8Text(value) {
  let current = String(value ?? '');
  for (let pass = 0; pass < 2; pass += 1) {
    const before = mojibakeScore(current);
    if (!before) break;
    const decoded = decodeOnce(current);
    if (decoded === current || mojibakeScore(decoded) >= before) break;
    current = decoded;
  }
  return current;
}
